export default function getPastDate(pastDate = 0, pastMonth = 0, pastYear = 0) {
  const date = new Date();
  date.setFullYear(date.getFullYear() - pastYear);
  date.setMonth(date.getMonth() - pastMonth);
  date.setDate(date.getDate() - pastDate);
  return date;
}
